import CodeEditor from '../codeEditor/CodeEditor.tsx';
import { WidgetProps } from '@rjsf/utils';
import { PYTHON_FUNCTION_INITIAL_VALUE } from '../../consts/codeEditorInitialValues';
import { useEffect } from 'react';
import { CodeEditorCard } from './CodeEditorWidget.styles';

interface CodeEditorWidgetProps extends WidgetProps {
  options: WidgetProps['options'] & {
    initialValue?: string;
    language?: string;
  };
}

const CodeEditorWidget = (props: CodeEditorWidgetProps) => {
  const language = props.options?.language ?? 'python';
  const fallback = language === 'python' ? PYTHON_FUNCTION_INITIAL_VALUE : '';
  const value = props.value ?? props.options?.initialValue ?? fallback;

  useEffect(() => {
    props.onChange(value);
  }, []);

  return (
    <CodeEditorCard elevation={0}>
      <CodeEditor onChange={props.onChange} language={language} height="30vh" value={value} readOnly={props.disabled} />
    </CodeEditorCard>
  );
};

export default CodeEditorWidget;
